import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import staticURL from 'lib/staticURL';
import {GetPipelineStepShape} from 'pipelines/PipelineTypes';

export const COMBINE_METHOD_ORDERED = [PipelineStepType.JOIN, PipelineStepType.UNION_DATASETS] as const;

export const COMBINE_METHOD_TO_ICON = {
  [PipelineStepType.JOIN]: staticURL('/static/img/analysis-tool/join.svg'),
  [PipelineStepType.UNION_DATASETS]: staticURL('/static/img/analysis-tool/union.svg'),
} as const;

export const COMBINE_METHOD_TO_TITLE = {
  [PipelineStepType.JOIN]: 'Join',
  [PipelineStepType.UNION_DATASETS]: 'Union',
} as const;

export const COMBINE_METHOD_TO_DESCRIPTION = {
  [PipelineStepType.JOIN]: 'Combine tables horizontally, merging rows',
  [PipelineStepType.UNION_DATASETS]: 'Combine tables vertically, merging columns',
} as const;

export type JoinType = GetPipelineStepShape<
  PipelineStepType.JOIN,
  0
>['config']['joinType']['choices'][number];

export const JOIN_TYPE_ORDERED: Array<JoinType> = [
  'LEFT_OUTER',
  'INNER',
  'RIGHT_OUTER',
  'FULL_OUTER',
  'POSITIONAL',
  // TODO(BNCH-129703): Add support for NATURAL join type in the UI
];

export const JOIN_TYPE_TO_IMAGE: Record<JoinType, string> = {
  LEFT_OUTER: staticURL('/static/img/analysis-tool/left_join.svg'),
  INNER: staticURL('/static/img/analysis-tool/inner_join.svg'),
  RIGHT_OUTER: staticURL('/static/img/analysis-tool/right_join.svg'),
  FULL_OUTER: staticURL('/static/img/analysis-tool/outer_join.svg'),
  POSITIONAL: staticURL('/static/img/analysis-tool/positional_join.svg'),
  // TODO(BNCH-129703): Update icon when we add NATURAL join type in the UI
  NATURAL: staticURL('/static/img/analysis-tool/natural_join.svg'),
};

export const JOIN_TYPE_TO_TITLE: Record<JoinType, string> = {
  LEFT_OUTER: 'Left join',
  INNER: 'Inner join',
  RIGHT_OUTER: 'Right join',
  FULL_OUTER: 'Full join',
  POSITIONAL: 'Append columns',
  // TODO(BNCH-129703): Update title when we add NATURAL join type in the UI
  NATURAL: 'Natural join',
};

export const JOIN_TYPE_TO_DESCRIPTION: Record<JoinType, string> = {
  LEFT_OUTER: 'Join all rows from left, matching rows from right',
  INNER: 'Join matching rows from both tables',
  RIGHT_OUTER: 'Join all rows from right, matching rows from left',
  FULL_OUTER: 'Join all rows from both tables',
  POSITIONAL: 'Merge rows based on index, without join keys',
  // TODO(BNCH-129703): Update description when we add NATURAL join type in the UI
  NATURAL: 'Unreleased',
};
